export default __webpack_public_path__ + "static/media/DownArrow.f3c00df9.svg";